import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import { statistics } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsSegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statistics && statistics.groupParamsSegment) || []}
        reportComponent={ReportComponent}
        translationKey="statistics"
    />
);

export default StatisticsSegments;
